import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input } from '@angular/core';
import { Chart } from 'chart.js';
@Component({
  selector: 'app-chart-bar',
  templateUrl: './chart-bar.component.html',
  styleUrls: ['./chart-bar.component.scss']
})
export class ChartBarComponent implements OnInit, AfterViewInit {
  @ViewChild('BarChartID')
  protected chartID: ElementRef;
  @Input('chartType')
  protected chartType: string;
  @Input('labels')
  protected labels: any[];
  @Input('chartData')
  protected chartData: any[];
  @Input('xAxesStacked')
  protected xAxesStacked: boolean = false;
  @Input('yAxesStacked')
  protected yAxesStacked: boolean = false;
  @Input('legendPosition')
  protected legendPosition: string = 'bottom';
  @Input('legendDisplay')
  legendDisplay: boolean = true;
  @Input('labelString')
  labelString: string = '';
  @Input('isLabelString')
  isLabelString: boolean = false;
  public chartBar: any;
  constructor() {}

  ngOnInit() {}
  ngAfterViewInit() {
    this.chartLoader();
  }

  chartLoader(): void {
    this.chartBar = new Chart(this.chartID.nativeElement, {
      type: this.chartType, // pie , line ,'doughnut' ....
      data: {
        labels: this.labels,
        datasets: this.chartData
      },
      options: {
        responsive: true,
        legend: {
          position: this.legendPosition,
          display: this.legendDisplay,
          onComplete: function (ctx) {
            console.log(ctx);
          }
        },
        animation: {
          animateScale: true,
          defaultColor: 'rgba(152, 152, 152, 0.5)',
          onComplete: function(ctx) {
            ctx.chart.ctx.shadowColor = 'rgba(152, 152, 152, 0.5)';
            ctx.chart.ctx.shadowBlur = 10;
            ctx.chart.ctx.shadowOffsetX = 2;
            ctx.chart.ctx.shadowOffsetY = 2;
          }
        },
        ticks: {
          // .. Other settings
          stepSize: Math.round(800 / 5) /* total/4 shows 0, 25%, 50%, 75%, 100% */,
          callback: function(value, index, values) {
            return (value / 800) * 100 + '%';
          }
        },
        scales: {
          xAxes: [
            {
              stacked: this.xAxesStacked
            }
          ],
          yAxes: [
            {
              stacked: this.yAxesStacked,
              scaleLabel: {
                display: this.isLabelString,
                labelString: this.labelString
              }
            }
          ]
        }
      }
    }); // Must be List // Type is string
  }
  public chartUpdate() {
    this.chartBar.resize();
    this.chartBar.update({
      duration: 800,
      lazy: true,
      easing: 'easeOutBounce'
    });
  }
}
